import { Hooper, Slide, Navigation } from "hooper";
// tslint:disable-next-line: no-submodule-imports
import "hooper/dist/hooper.css";

export interface HooperSettings {
    breakpoints?: Record<string, HooperSettings>;
    itemsToShow?: number;
    itemsToSlide?: number;
    initialSlide?: number;
    infiniteScroll?: boolean;
    centerMode?: boolean;
    vertical?: boolean;
    rtl?: boolean;
    autoPlay?: boolean;
    playSpeed?: number;
    mouseDrag?: boolean;
    touchDrag?: boolean;
    wheelControl?: boolean;
    keysControl?: boolean;
    shortDrag?: boolean;
    transition?: number;
    hoverPause?: boolean;
    trimWhiteSpace?: boolean;
    group?: string;
}
export interface HooperData {
    settings?: HooperSettings;
    containerHeight: number;
    containerWidth: number;
    slideHeight: number;
    slideWidth: number;
}

export { Hooper, Slide, Navigation };
